import { IDropdownItem } from '../interfaces/IDropdownItem';

export const getArrayFromObject = (obj: object): IDropdownItem[] => {
  return Object.entries(obj).map(([code, name]) => {
    return { code, name };
  });
};
